import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DurationPipe } from './duration.pipe';
import { HourstampPipe } from './hourstamp.pipe';
import { ItemFilterPipe } from './item-filter.pipe';
import { PluckPipe } from './pluck.pipe';
import { SlotDurationPipe } from './slot-duration.pipe';

export { DurationPipe } from './duration.pipe';
export { HourstampPipe } from './hourstamp.pipe';
export { ItemFilterPipe } from './item-filter.pipe';
export { PluckPipe } from './pluck.pipe';

@NgModule({
  declarations: [
    DurationPipe,
    HourstampPipe,
    ItemFilterPipe,
    PluckPipe,
    SlotDurationPipe
  ],
  exports: [
    HourstampPipe,
    ItemFilterPipe,
    DurationPipe,
    PluckPipe
  ],
  imports: [
    CommonModule
  ]
})
export class PipesModule { }
